export default {
  state: {
    alerts: [],
    alertCount: 0,
  },
  getters: {
    getAlerts: (state) => state.alerts,
  },
  mutations: {
    //newAlert:{msgType, msg}
    addAlert(state, { msgType, msg }) {
      state.alerts.push({ id: state.alertCount++, msg, msgType })
    },
    removeAlert(state, key) {
      state.alerts = state.alerts.filter((alert) => alert.id !== key)
    },
  },
  // actions: {},
}
